import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MusicService {
  private backgroundMusic: HTMLAudioElement | null = null;

  startBackgroundMusic(audioSource: string): void {
    this.stopBackgroundMusic();
    try {
      this.backgroundMusic = new Audio(audioSource);
      this.backgroundMusic.loop = true;
      this.backgroundMusic.volume = 0.4; // Set volume to 40%

      // Try to play immediately
      this.backgroundMusic.play().catch((error) => {
        // If autoplay fails, try again on user interaction
        console.log('Autoplay blocked, will start on user interaction', error);
        document.addEventListener('click', this.playOnUserInteraction.bind(this), { once: true });
        document.addEventListener('keydown', this.playOnUserInteraction.bind(this), { once: true });
      });

      this.backgroundMusic.addEventListener('error', (error) => {
        console.error('Audio loading error:', error);
      });
    } catch (error) {
      console.error('Failed to initialize background music:', error);
    }
  }

  private playOnUserInteraction(): void {
    if (this.backgroundMusic) {
      this.backgroundMusic.play().catch(error => {
        console.error('Failed to play background music on user interaction:', error);
      });
    }
  }

  stopBackgroundMusic(): void {
    if (this.backgroundMusic) {
      this.backgroundMusic.pause();
      this.backgroundMusic.currentTime = 0;
      this.backgroundMusic = null;
    }
  }
}
